import axios from "axios";

export const SET_TEAMFILTER = "set_teamfilter";
export const SET_YEARFILTER = "set_yearFilter";
export const SET_GYMNASTFILTER = "set_gymnastFilter";
export const SET_GYMNASTS = "set_gymnasts";
export const SET_MEETS = "set_meets";
export const SET_SCHEMA = "set_schema";
export const SET_SHOWLOADER = "set_showloader";
export const SET_DASHBOARD_DATA = "set_dashboard_data";
export const SET_NUMROWS = "set_numrows";
export const SET_COLS = "set_cols";
export const SET_ISVALIDTEAMYEAR = "set_isValidTeamYear";

const ROOT_URL = "https://www.roadtonationals.com/api/men";

export function getSchema(config) {
  const request = axios.get(`${ROOT_URL}/schema/${config.year}`);

  return (dispatch) => {
    request.then(response => {
      //console.log(response.data);
      let currTeam = config.team;
      if(response.data.teams["t"+currTeam] === undefined) {
        currTeam = 0;
      }
      let newTeams = [];
      Object.keys(response.data.teams).forEach(function(key) {
        newTeams.push({ id: key.substr(1, 2), name: response.data.teams[key] });
      });
      response.data.teams = newTeams;
      dispatch({type: SET_SCHEMA, payload: response.data});
    })
    .catch(error => {
      throw(error);
    });
  };
}

export function getGymnasts(config) {
  const request = axios.get(`${ROOT_URL}/gymnastssplit/${config.year}/${config.team}/1`);

  return (dispatch) => {
    request.then(response => {

      let gid = response.data.gymnasts[0] === undefined ? 0 : response.data.gymnasts[0].id;
      let payload = {
        gymnasts: response.data.gymnasts,
        meets: response.data.meets,
        teams: response.data.teams,
        years: response.data.years,
        gymnastFilter: Number(gid),
        teamFilter: Number(config.team),
        yearFilter: Number(config.year)
      };
      dispatch({type: SET_GYMNASTS, payload: payload});

      let team = config.team;
      if(Number(team) === 0){
        team = 2;
      }
      if (typeof(Storage) !== "undefined") {
        localStorage.lastTeamIDGA = Number(team);
      }
    })
    .catch(error => {
      throw(error);
    });
  };
}

export function getDashboard(config) {
  const request = axios.get(`${ROOT_URL}/dashboard/${config.year}/${config.team}`);
  return (dispatch) => {
    dispatch({type: SET_SHOWLOADER, payload: true});
    request.then(response => {
      console.log(response.data);
      let isValid = response.data.meets.length > 0 ? true : false;
      let payload = {
        data: response.data,
        isValidTeamYear: isValid,
        showLoader: false
      }
      dispatch({type: SET_DASHBOARD_DATA, payload: payload});
    });
  };
}

export function setTeamFilter(val) {
  return {
    type: SET_TEAMFILTER,
    payload: val
  };
}

export function setYearFilter(val) {
  return {
    type: SET_YEARFILTER,
    payload: val
  };
}

export function setGymnastFilter(val) {
  return {
    type: SET_GYMNASTFILTER,
    payload: val
  };
}

export function setGymnasts(val) {
  return {
    type: SET_GYMNASTS,
    payload: val
  };
}

export function setMeets(val) {
  return {
    type: SET_MEETS,
    payload: val
  };
}

export function setSchema(val) {
  return {
    type: SET_SCHEMA,
    payload: val
  };
}

export function setIsValidTeamYear(val) {
  return {
    type: SET_ISVALIDTEAMYEAR,
    payload: val
  };
}
